/* eslint-disable import/prefer-default-export */
import React from 'react'
import * as R from 'ramda'

import Select from '../../../form/Select'
import Input from '../../../form/Input'
import Checkbox from '../../../form/Checkbox'
import CheckboxGroup from '../../../form/CheckboxGroup'
import Switch from '../../../../UniformComponents/Switch'
import Mergefield from './Mergefield'
import Date from './Date'
import Benchmarks from './Benchmarks'
import Options from './Options'

export const renderField = (field, onBlur, register, unregister, store) => {
    const {
        name,
        label,
        type,
        path,
        options,
        isMandatory,
        fieldResets,
        promise,
        isMulti,
        subHeading,
        isClearable,
        placeholder,
        isDisabled,
    } = field

    switch (type) {
        case 'input':
            return (
                <Input
                    key={name}
                    name={name}
                    label={label}
                    subHeading={subHeading}
                    isMandatory={isMandatory}
                    register={register}
                    unregister={unregister}
                    defaultValue={R.pathOr(null, path, store.customTag)}
                    onBlur={(obj) => onBlur(obj, promise, fieldResets, path)}
                />
            )
        case 'checkbox':
            return (
                <Checkbox
                    key={name}
                    name={name}
                    label={label}
                    isMandatory={isMandatory}
                    register={register}
                    unregister={unregister}
                    className="exploriNativeCheckbox"
                    defaultChecked={R.pathOr(null, path, store.customTag)}
                    onBlur={(obj) => onBlur(obj, promise, fieldResets, path)}
                />
            )
        case 'select':
            return (
                <Select
                    key={name}
                    name={name}
                    label={label}
                    isMandatory={isMandatory}
                    isMulti={isMulti}
                    register={register}
                    unregister={unregister}
                    options={options}
                    value={R.pathOr(null, path, store.customTag)}
                    onBlur={(obj) => onBlur(obj, promise, fieldResets, path)}
                    blurOnClear={isMulti || isClearable}
                    isClearable={isClearable}
                    placeholder={placeholder}
                    showDisabled={isDisabled}
                />
            )
        case 'checkboxGroup':
            return (
                <CheckboxGroup
                    key={name}
                    name={name}
                    label={label}
                    isMandatory={isMandatory}
                    register={register}
                    unregister={unregister}
                    options={options}
                    onBlur={(obj) => onBlur(obj, promise, fieldResets, path)}
                    checkboxClassName="exploriNativeCheckbox"
                    isNotDefaultChecked
                    refreshOnRender
                    returnValueUnchanged
                    defaultChecked={R.pathOr([], path, store.customTag)}
                />
            )
        case 'switch':
            return (
                <div key={name} style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginLeft: '8px' }}>
                    {label && <label className="select-label">{label}</label>}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span>Off</span>
                        <Switch
                            onToggle={(isOn) => onBlur({ name, value: isOn }, promise, fieldResets, path)}
                            state={Boolean(R.pathOr(false, path, store.customTag))}
                            icon="fa-regular fa-check"
                        />
                        <span>On</span>
                    </div>
                </div>
            )
        case 'mergefield':
            return (
                <Mergefield
                    name={type}
                    store={store}
                    field={field}
                    register={register}
                    unregister={unregister}
                    options={options}
                    onBlur={(obj) => onBlur(obj, promise, fieldResets)}
                />
            )
        case 'answerOptions':
            return (
                <Options
                    name={type}
                    store={store}
                    field={field}
                    register={register}
                    unregister={unregister}
                    options={options}
                    onBlur={(obj) => onBlur(obj, promise, fieldResets)}
                />
            )
        case 'date':
            return (
                <Date
                    name={type}
                    store={store}
                    field={field}
                    register={register}
                    unregister={unregister}
                    options={options}
                    onBlur={(obj) => onBlur(obj, promise, fieldResets)}
                />
            )
        case 'benchmarks':
            return (
                <Benchmarks
                    store={store}
                    field={field}
                    register={register}
                    unregister={unregister}
                    options={options}
                    onBlur={(obj) => onBlur(obj, promise, fieldResets)}
                />
            )
        default:
            return null
    }
}
